import axios from "axios";
import { BACKEND_URL } from "../backendURL";


class ObserverService {

    getList() {
        const token = JSON.parse(localStorage.getItem('authUser'));
        const config = {
            headers: {
                'Authorization': "Token " + token.key
            },
        };

        const requestUrl = BACKEND_URL + "/api/patronage/my-observer-voters-new/";
        return axios.get(requestUrl, config);
    };


    getObserverStatus(token) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const requestUrl = BACKEND_URL + "/api/election/observer-status/";
        return axios.get(requestUrl, config);
    };


    confirmVote(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const requestUrl = BACKEND_URL + "/api/patronage/voting/";
        return axios.post(requestUrl, data, config);
    };


    deleteVote(token, data) {
        const config = {
            headers: {
                'Authorization': "Token " + token
            },
        };

        const requestUrl = BACKEND_URL + "/api/patronage/voting-delete/";
        return axios.post(requestUrl, data, config);
    };

}

export default new ObserverService();